var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "left",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66115 2.06621V1.03094C9.66115 0.941211 9.55803 0.891658 9.48839 0.946568L3.45088 5.66219C3.39959 5.70209 3.35808 5.75317 3.32953 5.81154C3.30098 5.86992 3.28613 5.93404 3.28613 5.99902C3.28613 6.06401 3.30098 6.12813 3.32953 6.18651C3.35808 6.24488 3.39959 6.29596 3.45088 6.33585L9.48839 11.0515C9.55937 11.1064 9.66115 11.0568 9.66115 10.9671V9.93184C9.66115 9.86621 9.63035 9.80327 9.57946 9.76309L4.75803 5.99969L9.57946 2.23496C9.63035 2.19478 9.66115 2.13184 9.66115 2.06621Z",
    fill: "#d9d9d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.a73d710dd1279dbaa0f982ec3b85bc2e.svg";
export { ForwardRef as ReactComponent };